import React, { Component } from 'react';

class Error extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: props.user.errors,
        };
    }

    componentDidMount() {
        this.props.actions.userActions.clearErrors();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.errors !== this.props.user.errors) {
            this.setState({
                message: this.props.user.errors,
            });
        }
    }

    render() {
        if (this.state.message) {
            const alertType = 'alert-danger';

            return (
                <div className={alertType + ' alert text-center entry-alert'} role='alert'>
                    {this.state.message.replace(/<br\/>/g, ' ')}
                </div>
            );
        } else {
            return <></>;
        }
    }
}

export default Error;
